import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { isoToDisplayDateTime } from "../components/DateInput";

const fmt = (iso) => isoToDisplayDateTime(iso);

export default function PengajuanKonfirmasiPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  if (!state?.nomor) { navigate("/formulir", { replace: true }); return null; }
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="pengajuan-konfirmasi-page">
      <Card className="max-w-md w-full p-8 rounded-2xl text-center space-y-4">
        <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-600" />
        <h1 className="text-2xl font-bold text-slate-900">Pengajuan Berhasil Diterima</h1>
        <p className="text-sm text-slate-600">Simpan nomor pengajuan berikut untuk keperluan komunikasi dengan sekretariat gereja.</p>
        <div className="rounded-xl bg-slate-100 p-4">
          <div className="text-xs uppercase tracking-wider text-slate-500">Nomor Pengajuan</div>
          <div className="text-2xl font-bold font-mono text-[hsl(224,64%,33%)]" data-testid="konfirmasi-nomor">{state.nomor}</div>
        </div>
        <div className="text-sm text-slate-700"><div>Jenis: <b data-testid="konfirmasi-jenis">{state.jenis}</b></div><div>Waktu: <span data-testid="konfirmasi-waktu">{fmt(state.waktu)}</span></div></div>
        {state.duplikat && <p className="text-xs text-amber-700">Pengajuan yang sama sudah kami terima sebelumnya; nomor di atas adalah nomor pengajuan tersebut.</p>}
        <Button variant="outline" className="min-h-[44px] rounded-xl" onClick={() => navigate("/formulir")} data-testid="ajukan-lagi-btn">Ajukan Pelayanan Lain</Button>
      </Card>
    </div>
  );
}
